/* import __COLOCATED_TEMPLATE__ from './dataset-ic-select-item.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import templateOnlyComponent from '@ember/component/template-only';
import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface Args {
  componentAttrs: ComponentAttrs;
}

interface ComponentAttrs {
  text: string;
  description: string;
  icon: InterfaceIconName;
}

const DatasetIcSelectItem = templateOnlyComponent<Args>();
export default DatasetIcSelectItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Custom::ChartBuilder::FilterBar::DatasetIcSelectItem': typeof DatasetIcSelectItem;
  }
}
